module.exports = __webpack_public_path__ + "static/media/bg_Page08.5a1492b4.jpg";